import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthManager } from '@infra-adapters/services/auth.service';

/**
 * Fuerza el cambio de contraseña SOLO a repartidores en su primer login (su
 * contraseña la fija el admin). Se identifica al repartidor por el módulo
 * courier_deliveries; el resto del backoffice nunca se gatea aunque arrastre un
 * first_login=true histórico. La pantalla /change-password vive fuera del
 * layout, así que queda accesible para romper el ciclo.
 */
@Injectable({ providedIn: 'root' })
export class FirstLoginGuard implements CanActivate {
  constructor(private auth: AuthManager, private router: Router) {}

  canActivate(): boolean {
    const user = this.auth.UserSessionData();
    const isCourier = !!user?.modules?.['courier_deliveries'];
    if (user?.first_login && isCourier) {
      this.router.navigate(['/change-password']);
      return false;
    }
    return true;
  }
}
